<template>
  <div class="container" >
    <div class="title">
      <a href="#" @click="back">返回</a>
      <span>{{info.infoTitle}}</span><span class="time">{{info.infoDt | time}}</span>
    </div>
    <div v-html="info.infoDesc"></div>
  </div>
</template>
<script>
  import dateFormate from '../uitil/dateFormat'
  export default{
    data(){
      return {
          info:""
      }
    },
    props: {},
    methods: {
        back(){
            this.$router.go(-1);
        }
    },
    filters:{
      time(time){
        return dateFormate(time);
      }
    },
    mounted(){
      let id = this.$route.params.id;
//      console.log(id);
      axios.request({
        url: '/medapp/api/con/info/get',
        method: 'post', // default
        data: {
          info_id: id   //新闻id
        }
      }).then((response) => {
//        console.log(response.data);
        this.info = response.data.info;
      })
    }
  }
</script>
<style scoped>
  .container{
    width: 950px;
    border: 1px solid #eee;
    padding: 5px;
    margin: 20px auto;
  }
  .title{
    color: #5cadff;
    font-size: 14px;
    border-bottom: 1px solid #00c261;
    margin-bottom: 30px;
    line-height: 2;
  }
  .title span{
    margin-left: 12px;
  }
  .time{
    float: right;
  }
</style>



// WEBPACK FOOTER //
// inews_con.vue?cee4bfd2